<template>
    <div class="schedules-content">
        <div class="ticket-search-filter">
            <div class="container p-0">
                <form class="form-inline">
                    <div class="col-md-6 col-lg-3 place-from">
                        <div class="kyXtnm">
                            <div class="ghBeQA nmkmkl">
                                <div class="gZRXuM">
                                    <img src="../../../assets/images/location.svg" alt="">
                                </div>
                                <selector-region ref="selectFrom" v-model="from"
                                                 :placeholder="'Nhập nơi đi'"></selector-region>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-3 place-to">
                        <div class="kyXtnm">
                            <div class="ghBeQA nmkmkl">
                                <div class="gZRXuM">
                                    <img src="../../../assets/images/location.svg" alt="">
                                </div>
                                <selector-region ref="selectTo" v-model="to"
                                                 :placeholder="'Nhập nơi đến'"></selector-region>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-2 vehicle-categories">
                        <div class="kyXtnm">
                            <div class="ghBeQA nmkmkl">
                                <div class="gZRXuM">
                                    <img src="../../../assets/images/bus-icon.svg" alt="">
                                </div>
                                <selector-vehicle-category ref="selectVehicle"
                                                           v-model="queryParams.vehicle_category_id"></selector-vehicle-category>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-2 date-start">
                        <div class="ftSWJG njlolp">
                            <span class="dFcWyt ant-input-affix-wrapper ant-input-affix-wrapper-lg lolpplp">
                                <span class="ant-input-prefix">
                                    <img src="../../../assets/images/datepicker.svg" alt="">
                                </span>
                                <custom-datepicker ref="selectTime" v-model="queryParams.from_time"
                                                   :placeholder="'Nhập ngày đi'"></custom-datepicker>
                            </span>
                        </div>
                    </div>
                    <div class="col-lg-2 btn-find text-right">
                        <button id="searchSubmit" name="searchSubmit" type="button" class="btn"
                                @click.stop="findTicket">
                            Tìm vé xe
                        </button>
                    </div>
                </form>
            </div>
        </div>

        <header id="header">
            <div class="container">
                <div class="col-md-12 col-sm-12 col-12">
                    <div class="row">
                        <div class="col-md-6">
                            <h1 class="title-text-route">
                                Vé xe từ {{getProp(paramsLocalStorage, 'from._name', '')}} đến {{getProp(paramsLocalStorage, 'to._name', '')}}
                            </h1>
                        </div>
                    </div>
                </div>
            </div>
        </header>

        <section class="searchResults">
            <div id="main">
                <div class="replaceDiv">
                    <div id="searchResults">
                        <ul class="result-list" v-if="schedules && schedules.length > 0">
                            <template v-for="(item) in schedules">
                                <li v-bind:key="item.id" v-bind:id="item.id"
                                    class="result-item col-12 col-sm-12 col-md-12">
                                    <div class="container">
                                        <div v-show="widthScreen >= 992">
                                            <div class="row mr-0 ml-0">
                                                <div class="col-2 col-md-3 col-sm-3 col-lg-2">
                                                    <div class="row">
                                                        <div class="pull-left comp-name-container">
                                                            <h6 class="mt-0 mb-3 comp-name-title"
                                                                title="Luxury Transport">Luxury Car</h6>
                                                            <div class="col-lg-12 service-plus-in">
                                                                <img src="../../../assets/images/wifi.svg"
                                                                     alt="Xe có wifi">
                                                                <img src="../../../assets/images/Water.svg"
                                                                     alt="Xe phục vụ nước uống">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-4 col-md-5 col-sm-3 col-lg-4">
                                                    <div class="col-12 ml-2 text-center">
                                                        <div class="row">
                                                            <div class="col-5 col-md-5 col-sm-12 text-left-from">
                                                                <h6 class="mt0 mb-1">
                                                                    {{format(new Date(item.start_time), 'HH:mm')}}
                                                                </h6>
                                                            </div>
                                                            <div class="col-2 col-md-2 col-sm-12 text-left p-0">
                                                                <i style="display: inline-block;margin-top:-10px;line-height:15px;font-size:12px;text-align:center;">
                                                                    {{Math.round((getProp(item, 'end_time', 0) -
                                                                    getProp(item, 'start_time', 0))/1000/60/60)}}h
                                                                    <br>
                                                                    <img style="width:45px;height:10px;"
                                                                         src="../../../assets/images/from-to2.png" alt="">
                                                                    <br>
                                                                    dự kiến
                                                                </i>
                                                            </div>
                                                            <div class="col-5 col-md-5 col-sm-12 text-left-to">
                                                                <h6 class="mt-0 mb-1">
                                                                    {{format(new Date(item.end_time), 'HH:mm')}}
                                                                </h6>
                                                            </div>
                                                            <div class="clearfix"></div>
                                                            <div class="pull-left w-100">
                                                                <div class="row ml-0">
                                                                    <div class="col-5 col-md-5 col-sm-5 text-left">
                                                                        <a class="ticket-detail-tab-link"
                                                                           style="color:#333" href="javascript:void(0)">
                                                                            {{getProp(item, 'voyages[0].from', '')}}
                                                                        </a>
                                                                    </div>
                                                                    <div class="col-2 col-md-2 col-sm-2 p-0"></div>
                                                                    <div class="col-5 col-md-5 col-sm-5 text-left pl-2">
                                                                        <a class="ticket-detail-tab-link"
                                                                           style="color:#333" href="javascript:void(0)">
                                                                            {{getProp(item, 'voyages[0].to', '')}}
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-2 col-md-2 col-sm-3 col-lg-2">
                                                    <div class="mb-1 text-left font-weight-bold"
                                                         style="margin-bottom:3px !important">
                                                        {{getProp(item, 'vehicle_category.name', '')}}
                                                    </div>
                                                    <div class="clearfix"></div>
                                                    <div class="service-call text-left mt-3">
                                                        <span>{{getProp(item, 'voyages[0].pivot.remain_seat')}}</span>
                                                        Ghế trống
                                                    </div>
                                                </div>
                                                <div class="col-2 col-md-2 col-sm-3 col-lg-2">
                                                    <div class="mb-1 text-left font-weight-bold"
                                                         style="margin-bottom:3px !important">
                                                        Ngày
                                                    </div>
                                                    <div class="clearfix"></div>
                                                    <div class="service-call text-left mt-3">
                                                        <span>{{format(new Date(getProp(item, 'start_time')), 'dd-MM-yyyy')}}</span>
                                                    </div>
                                                </div>
                                                <div class="col-4 col-md-2 col-sm-3 col-lg-2 pr-0 text-right">
                                                    <h6 class="mt-0 price">
                                                        {{getTicketPrice(getProp(item, 'tickets', []))}}
                                                        <small style="vertical-align: top;" class="unit-price-small">đ
                                                        </small>
                                                    </h6>

                                                    <p class="m-0">
                                                        <a v-if="!item.displayDetail"
                                                           class="btn-vxr-lg btn pull-right w100"
                                                           href="javascript:void(0)"
                                                           title="Nhấp để đặt vé"
                                                           @click="openDetail(item)">Chọn chỗ
                                                        </a>
                                                        <a v-if="item.displayDetail"
                                                           title="Nhấp để đóng lại"
                                                           href="javascript:void(0)"
                                                           class="btn btn-lg btn-vxr-gray-lg pull-right w100"
                                                           @click="closeDetail(item)">Đóng lại
                                                        </a>
                                                    </p>
                                                </div>
                                            </div>
                                            <div class="row mt-1 ml-0">
                                                <b>* Lưu ý: &nbsp;</b> Có xe tăng cường quý khách có thể gọi trực tiếp cho tổng đài 19000392 để đặt chỗ mình muốn (phòng trường hợp xe hết chỗ).
                                            </div>
                                        </div>
                                        <div v-show="widthScreen < 991">
                                            <div class="col-12">
                                                <div class="row">
                                                    <div class="col-7">
                                                        <div>
                                                            <h6>
                                                                {{format(new Date(item.start_time), 'HH:mm')}}
                                                            </h6>
                                                            <i class="pl-2">→</i>
                                                            <h6>{{format(new Date(item.end_time), 'HH:mm')}}</h6>
                                                            <span class="totalHours">(dự kiến {{Math.round((getProp(item, 'end_time', 0) - getProp(item, 'start_time', 0))/1000/60/60)}}h)</span>
                                                        </div>
                                                    </div>
                                                    <div class="col-5 text-right">
                                                        <h6 class="mt-0 price">
                                                            {{getTicketPrice(getProp(item, 'tickets', []))}}
                                                            <small style="vertical-align: top;"
                                                                   class="unit-price-small">đ
                                                            </small>
                                                        </h6>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-6">
                                                        <h6 class="comp-name-title">Luxury Car</h6>
                                                    </div>
                                                    <div class="col-6 text-right">
                                                        <p class="service-call">
                                                            <span>{{getProp(item, 'voyages[0].pivot.remain_seat')}}</span>
                                                            Ghế trống
                                                        </p>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-6">
                                                        <div class="mb-2 vehicle-type-p">
                                                            {{getProp(item, 'voyages[0].from', '')}} → {{getProp(item, 'voyages[0].to', '')}}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-6">
                                                        <div class="mb-2 vehicle-type-p">
                                                            {{getProp(item, 'vehicle_category.name', '')}}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-6">
                                                        <div class="vehicle-type-p">
                                                            {{format(new Date(getProp(item, 'start_time')), 'dd-MM-yyyy')}}
                                                        </div>
                                                    </div>
                                                    <div class="col-6 text-right">
                                                        <p style="margin:0;">
                                                            <a v-if="!item.displayDetail"
                                                               class="btn-vxr-lg btn pull-right w100"
                                                               @click="openDetail(item)"
                                                               href="javascript:void(0)"> Chọn chỗ
                                                            </a>
                                                            <a v-if="item.displayDetail"
                                                               title="Nhấp để đóng lại"
                                                               @click="closeDetail(item)"
                                                               class="btn btn-lg btn-vxr-gray-lg w100"
                                                               href="javascript:void(0)"> Đóng lại
                                                            </a>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <li v-bind:key="item.id + '-detail'" v-if="item.displayDetail"
                                    class="ticket-booking-details col-12 col-md-12 col-xs-12 pb-3 pt-2 m-0">
                                    <booking-detail v-if="widthScreen >= 992" :schedule="item"
                                                    :query_params="query"></booking-detail>
                                    <booking-detail-mobile v-if="widthScreen < 991" :schedule="item"
                                                           :query_params="query"></booking-detail-mobile>
                                </li>
                            </template>
                        </ul>
                    </div>
                </div>
            </div>
        </section>

        <section class="spin" ref="loadContainer">
        </section>
    </div>
</template>

<script>
    import 'bootstrap';
    import BookingDetail from "../booking-detail/BookingDetail";
    import BookingDetailMobile from "../booking-detail-mobile/BookingDetailMobile";
    import {RepositoryFactory, MixinHelper, eventBus, EVENTS} from "../../shared/services";
    import format from 'date-fns/format';
    import { SelectorRegion, SelectorVehicleCategory, CustomDatepicker } from "../../shared/components";
    import {required, minValue} from "vuelidate/lib/validators";
    import {HCROUTES} from "../../shared/constants/Constant";

    const repo = RepositoryFactory.get('schedules');
    export default {
        name: "Schedules",
        mixins: [MixinHelper],
        components: {
            CustomDatepicker,
            SelectorVehicleCategory,
            SelectorRegion,
            BookingDetailMobile,
            BookingDetail,
        },
        created() {
            this.paramsLocalStorage = this.retrieveData('params');
            this.from = this.getProp(this.paramsLocalStorage, 'from', null);
            this.to = this.getProp(this.paramsLocalStorage, 'to', null);
            this.queryParams.vehicle_category_id = Number(this.getProp(this.$route.query, 'vehicle_category_id', 0));
            this.queryParams.from_time = this.getProp(this.paramsLocalStorage, 'from_time', 0);

            this.query = {...this.query, ...this.$route.query};
            this.listSchedules(this.query);
        },
        mounted() {
            this.$nextTick(() => {
                window.addEventListener('resize', () => {
                    this.widthScreen = window.innerWidth;
                });
            });
            this.scroll();
        },
        data() {
            return {
                from: null,
                to: null,
                widthScreen: window.innerWidth,
                schedules: [],
                format,
                paramsLocalStorage: null,
                queryParams: {
                    vehicle_category_id: 0,
                    from_time: 0,
                    from_district: 0,
                    to_district: 0,
                    from_province: 0,
                    to_province: 0,
                },
                query: {
                    page: 1,
                    limit: 15
                },
                meta: null
            };
        },
        validations: {
            from: {
                required
            },
            to: {
                required
            },
            queryParams: {
                // vehicle_category_id: {
                //     minValue: minValue(1)
                // },
                from_time: {
                    minValue: minValue(1)
                },
            }
        },
        methods: {
            openDetail(item) {
                this.schedules.map(schedule => {
                    schedule.displayDetail = false;
                });
                item.displayDetail = true;
            },
            closeDetail(item) {
                item.displayDetail = false;
            },
            listSchedules(params) {
                repo.list(params)
                    .then(resp => {
                        this.meta = this.getProp(resp, 'data.meta', null);
                        this.schedules = this.getProp(resp, 'data.datas', []).map(function (schedule) {
                            return {...schedule, displayDetail: false};
                        });
                        if (!this.schedules || this.schedules.length === 0) {
                            eventBus.$emit(EVENTS.not_found_schedule, {...{}, ...this.queryParams});
                        }
                    })
                    .catch(err => {
                        eventBus.$emit(EVENTS.not_found_schedule, {...{}, ...this.queryParams});
                    })
            },
            loadMoreSchedules(params) {
                const loader = this.$loading.show({
                    container: this.$refs.loadContainer,
                    color: '#f9af00',
                });
                repo.loadMore(params)
                    .then(resp => {
                        this.schedules = [...this.schedules, ...this.getProp(resp, 'data.datas', []).map(function (schedule) {
                            return {...schedule, displayDetail: false};
                        })];
                        this.meta = this.getProp(resp, 'data.meta', null);
                    })
                    .catch(err => {
                    })
                    .finally(() => loader.hide())
            },
            getTicketPrice(tickets) {
                const ticketsPrice = tickets.map(ticket => ticket.price);
                const min = Math.min(...ticketsPrice);
                const max = Math.max(...ticketsPrice);
                return min.toLocaleString('us') + ' - ' + max.toLocaleString('us');
            },
            findTicket() {
                this.$v.from.$touch();
                if (this.$v.from.$pending || this.$v.from.$error) {
                    this.$refs.selectFrom.openDropDown();
                    return;
                }

                this.$v.to.$touch();
                if (this.$v.to.$pending || this.$v.to.$error) {
                    this.$refs.selectTo.openDropDown();
                    return;
                }

                // this.$v.queryParams.vehicle_category_id.$touch();
                // if (this.$v.queryParams.vehicle_category_id.$pending || this.$v.queryParams.vehicle_category_id.$error) {
                //     this.$refs.selectVehicle.select();
                //     return;
                // }

                this.$v.queryParams.from_time.$touch();
                if (this.$v.queryParams.from_time.$pending || this.$v.queryParams.from_time.$error) {
                    this.$refs.selectTime.openCalendar();
                    return;
                }
                const p = {
                    ...{},
                    from: this.from,
                    to: this.to,
                    vehicle_category_id: this.queryParams.vehicle_category_id,
                    from_time: this.queryParams.from_time
                };
                this.storeData('params', p);
                this.$router.replace({name: HCROUTES.schedule, query: this.filterParams(this.queryParams)}).catch(err => {});
            },
            scroll() {
                window.onscroll = () => {
                    let bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight >= document.documentElement.scrollHeight - 1;
                    if (bottomOfWindow) {
                        if (this.query.page < this.getProp(this.meta, 'last_page', 0)) {
                            this.query.page++;
                            this.loadMoreSchedules(this.query);
                        }
                    }
                }
            }
        },
        watch: {
            from(val) {
                if (val) {
                    if (val._province_id !== undefined && val._province_id !== null) {
                        this.queryParams.from_district = val.id;
                        this.queryParams.from_province = 0;
                    } else {
                        this.queryParams.from_province = val.id;
                        this.queryParams.from_district = 0;
                    }
                }
            },
            to(val) {
                if (val) {
                    if (val._province_id !== undefined && val._province_id !== null) {
                        this.queryParams.to_district = val.id;
                        this.queryParams.to_province = 0;
                    } else {
                        this.queryParams.to_province = val.id;
                        this.queryParams.to_district = 0;
                    }
                }
            },
        },
        beforeDestroy() {
            eventBus.$emit(EVENTS.off_not_found_schedule_page);
        }
    }
</script>

<style>
    .nmkmkl input {
        height: 40px;
        width: 0;
        font-size: 15px;
    }

    .nmkmkl .v-select {
        border-radius: 4px;
    }

    .nmkmkl div {
        left: 20px !important;
    }

    .nmkmkl .faoMZh {
        width: 14px;
        height: 26px;
    }

    .nmkmkl input.vs__search {
        padding-left: 50px;
    }

    .nmkmkl .vs__selected {
        font-size: 15px;
    }

    .njlolp .vdp-datepicker input {
        border-radius: 4px;
    }

    .lolpplp .vdp-datepicker input {
        height: 40px;
        font-size: 15px;
    }

    .lolpplp .eqZzUd {
        width: 17px;
        height: 26px;
    }

    .lolpplp .ant-input-prefix {
        left: 20px;
    }
</style>
<style>
    @import '../../../../node_modules/bootstrap/dist/css/bootstrap.min.css';

    .spin {
        position: relative;
        display: block;
        height: 80px;
        width: 100%;
    }

    header {
        display: block;
    }

    #header {
        padding: 15px 0;
        background: #efefef;
    }

    .title-text-route {
        font-size: 19px;
        font-weight: 700;
        line-height: 28px;
        padding: 0;
        margin: 0 12px 0 0;
        text-align: left;
    }

    .ticket-search-filter {
        background: #f9af00;
        margin-top: 0;
        margin-bottom: 0;
        padding: 10px 0;
    }

    .ticket-search-filter .form-inline {
        padding-top: 5px;
        padding-bottom: 5px;
    }

    .ticket-search-filter .switchButton {
        font-weight: 700;
        margin-left: 25px;
        margin-right: 5px;
        font-size: 35px;
        color: #fff;
    }

    .ticket-search-filter #searchSubmit {
        color: #fff;
        background: #177bd0 !important;
        padding: 9px 25px;
        border-radius: 5px !important;
        font-size: 16px;
        font-weight: 700;
        margin-top: 0;
    }

    .result-list {
        width: 100%;
        padding: 0;
        list-style: none;
    }

    .result-list li.result-item {
        width: 100%;
        background-color: #fff;
        margin-bottom: 3px;
        box-shadow: 0 1px 3px #c3c3c3;
        padding: 0;
        list-style: none;
    }

    .result-list .container {
        padding: 30px 0;
    }

    .payoo-offer-container {
        margin-left: 35px;
    }

    .offer-tag, .offer-tag:after {
        color: #fff;
        display: inline-block;
    }

    .offer-tag {
        background: #1867bc;
        font-size: 8px;
        margin-top: 5px;
        text-transform: uppercase;
        text-align: left;
        margin-left: 0;
        padding: 5px 8px;
        position: relative;
        text-decoration: none;
        min-width: 69px;
    }

    .offer-tag:before {
        width: 0;
        height: 0;
        border-top: 11px solid transparent;
        border-bottom: 11.1px solid transparent;
        border-left: 10px solid #1867bc;
        position: absolute;
        top: 0;
        left: 69px;
    }

    .offer-tag:after {
        content: "\f111";
        vertical-align: middle;
        margin-right: 5px;
        position: absolute;
        top: 8px;
        right: -7px;
        font: normal normal normal 6px/1 FontAwesome;
    }

    .btn-vxr-lg:before, .offer-tag:before {
        content: "";
    }

    .comp-name-container {
        width: 100%;
        background: url(../../../assets/images/bus-icon-403D3D.svg) 100% no-repeat;
        background-size: 25px;
        background-position-x: 0;
        background-position-y: 0;
        padding-left: 35px;
    }

    .pull-left {
        float: left !important;
    }

    .pull-right {
        float: right !important;
    }

    .comp-name-title {
        width: 87% !important;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    .BusQualityRating, .searchResults h6 {
        font-weight: 700;
        display: inline-block;
    }

    .searchResults h6 {
        font-size: 16px;
        width: 100%;
    }

    .service-plus-in {
        margin: 10px 0;
        padding: 0;
    }

    img {
        border: 0;
        vertical-align: middle;
    }

    .service-plus-in img {
        display: inline-block;
        width: 20px;
        margin-right: 15px;
    }

    .ticket-detail-tab-link {
        white-space: nowrap;
    }

    .benefit-icons {
        margin: 10px 0 30px;
    }

    .busInfo {
        list-style-type: none;
        display: inline-block;
        padding: 0 !important;
        width: 100%;
        text-align: center;
    }

    .hinh-anh {
        text-align: left !important;
    }

    .text-left-from, .text-left-to {
        text-align: left !important;
    }

    .link-lich-trinh {
        width: 100% !important;
        text-align: center !important;
    }

    .ticket-detail-tab-link {
        white-space: nowrap;
    }

    .btn-vxr-lg, .glyphicon, .ticket-search-filter .form-group {
        position: relative;
    }

    .btn-vxr-lg {
        box-sizing: content-box;
        display: inline-block;
        padding: 10px 10px 10px 25px;
        color: #684d18;
        font-weight: 700;
        font-size: 14px;
        background-repeat: no-repeat;
        background-image: -webkit-radial-gradient(0 50% circle, rgba(255, 255, 224, 0) .4em, #ffffe0 .5em), -webkit-radial-gradient(100% 50% circle, rgba(255, 255, 224, 0) .4em, #ffffe0 .5em);
        background-image: radial-gradient(circle at 0 50%, rgba(255, 255, 224, 0) .4em, #f9af00 .5em), radial-gradient(circle at 100% 50%, rgba(255, 255, 224, 0) .4em, #f9af00 .5em);
        background-position: top left, top right;
        background-color: transparent !important;
        border: none;
        box-shadow: none;
        border-radius: 3px !important;
    }

    .btn-vxr-lg:before {
        background-image: url(../../../assets/images/bus-icon-6D4415.svg);
        background-repeat: no-repeat;
        float: left;
        left: 12px;
        top: 7px;
        position: absolute;
        border-right: 1.8px solid #e5a100;
        padding-right: 5px;
        height: 28px;
        padding-top: 5px;
        width: 22px;
        background-size: 15px 28px;
    }

    .ticket-booking-details {
        background: #F0F0F0 !important;
    }

    .btn-vxr-gray-lg {
        box-sizing: content-box;
        display: inline-block;
        position: relative;
        padding: 10px 10px 10px 25px;
        color: #684d18;
        font-weight: 700;
        font-size: 14px;
        background-repeat: no-repeat;
        background-image: -webkit-radial-gradient(0 50% circle, rgba(255, 255, 224, 0) .4em, #ffffe0 .5em), -webkit-radial-gradient(100% 50% circle, rgba(255, 255, 224, 0) .4em, #ffffe0 .5em);
        background-image: radial-gradient(circle at 0 50%, rgba(255, 255, 224, 0) .4em, #d4d4d4 .5em), radial-gradient(circle at 100% 50%, rgba(255, 255, 224, 0) .4em, #d4d4d4 .5em);
        background-position: top left, top right;
        background-color: #fff !important;
        border: none;
        box-shadow: none;
        border-radius: 3px;
    }

    .btn-vxr-gray-lg:before {
        /*content: url(https://storage.googleapis.com/fe-production/images/General/vexere-bus-icon-sm.svg);*/
        content: "";
        float: left;
        left: 12px;
        top: 7px;
        position: absolute;
        border-right: 1.8px solid #c1bebe;
        padding-right: 5px;
        height: 28px;
        padding-top: 6px;
        width: 20px;
    }

    .w100 {
        width: 100px;
    }

    @media (min-width: 992px) {
        .visible-lg {
            display: block;
        }

        .visible-md {
            display: none;
        }

        .place-from {
            padding-left: 0;
        }

        .btn-find {
            text-align: right;
            padding-right: 0;
        }

        .vehicle-categories {
            padding-right: 0;
        }

        .date-start {
            padding-right: 0;
        }
    }

    @media (max-width: 991px) {
        .visible-lg {
            display: none;
        }

        .visible-md {
            display: block;
        }

        .place-from {
            padding-left: 15px;
            margin-bottom: 5px;
        }

        .place-to {
            margin-bottom: 5px;
        }

        .vehicle-categories {
            margin-bottom: 5px;
        }

        .date-start {
            margin-bottom: 5px;
        }

        .searchResults h6 {
            font-size: 14px;
            width: initial;
        }

        .star-mobile i {
            font-size: 10px;
        }

        .totalHours {
            font-size: 11px !important;
            margin-left: 0;
            float: none;
        }

        .searchResults h6.price, .unit-price-small {
            color: #333 !important;
            width: initial;
            margin: 0;
        }

        .comp-name-title {
            width: initial !important;
            font-size: 14px !important;
            margin: 8px 0;
        }

        .service-call {
            font-size: 14px !important;
            margin: 8px 0;
            font-weight: 700;
        }

        .ticket-search-filter #searchSubmit {
            margin-top: 10px;
            width: 100%;
        }
    }

    @media (max-width: 575px) {
        .vehicle-type-p {
            font-size: 12px;
        }
    }

</style>
